import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function Header() {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setIsSticky(window.scrollY > 150);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div>
      {/* Spinner Start */}
      {/* <div
      id="spinner"
      className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
    >
      <div
        className="spinner-border text-primary"
        style={{ width: "3rem", height: "3rem" }}
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div> */}
      {/* Spinner End */}

      {/* Topbar Start */}
      <div className="container-fluid bg-dark px-5 d-none d-lg-block">
        <div className="row gx-0">
          <div className="col-lg-6 text-center text-lg-start mb-2 mb-lg-0">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: 45 }}
            >
              <small className="me-3 text-light">
                <i className="fa fa-map-marker-alt me-2" />
                Denver, Colorado, USA
              </small>
              <small className="me-3 text-light">
                <i className="fa fa-phone-alt me-2" />
                +1 303-656-7737
              </small>
              <small className="text-light">
                <i className="fa fa-envelope-open me-2" />
                david.murphy@fora.travel
              </small>
            </div>
          </div>

          {/* <div className="col-lg-6 text-center text-lg-start mb-2 mb-lg-0">
            <div
              className="d-inline-flex align-items-center overflow-hidden scrolling-container"
              style={{ height: 45, width: '100%' }}
            >
              <small className="text-light scrolling-text">
                Enter Promo Code GayAF For 50% off a Fiji Vacation Package
              </small>
            </div>
          </div> */}

          <div className="col-lg-6 text-center text-lg-end">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: 45 }}
            >
              <Link
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                to="/"
              >
                <i className="fab fa-facebook-f fw-normal" />
              </Link>

              <a
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
                href="https://www.instagram.com/theoutposttravels/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram fw-normal" />
              </a>

              {/* <a
                className="btn btn-sm btn-outline-light btn-sm-square rounded-circle"
                to=""
              >
                <i className="fab fa-youtube fw-normal" />
              </a> */}
            </div>
          </div>
        </div>
      </div>
      {/* Topbar End */}

      {/* Navbar & Hero Start */}
      <div className="container-fluid position-relative p-0">
        <nav
          className={`navbar navbar-expand-lg navbar-light px-4 px-lg-5 py-3 py-lg-0 ${isSticky ? "sticky-top" : ""
            }`}
        >
          <Link to="/" className="navbar-brand p-0">
            <img
              src={
                isSticky
                  ? "/assets/img/outpost_gentlemen_rugged_black_adjusted.svg"
                  : "/assets/img/outpost_gentlemen_rugged_white_adjusted.svg"
              }
              alt="Outpost Gentlemen Logo"
              style={{ height: "300px", width: "auto" }}
            />

            {/* <img src="img/logo.png" alt="Logo"> */}
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="fa fa-bars" />
          </button>

          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0">
              <Link to="/" className="nav-item nav-link">
                Home
              </Link>
              <Link to="/About" className="nav-item nav-link">
                About Us
              </Link>
              <Link to="/Services" className="nav-item nav-link">
                Services
              </Link>

              <Link to="/travelguides" className="nav-item nav-link">
                Travel Guides
              </Link>
              {/* 
              <div className="nav-item dropdown">
                <Link
                  to="#"
                  className="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Pages
                </Link>
                <div className="dropdown-menu m-0">
                  <Link to="/Destination" className="dropdown-item">
                    Destination
                  </Link>
                  <Link to="/Booking" className="dropdown-item">
                    Booking
                  </Link>
                  <Link to="/TravelGuides" className="dropdown-item">
                    Travel Guides
                  </Link>
                  <Link to="/Testimonial" className="dropdown-item">
                    Testimonial
                  </Link>
                  <Link to="/Error" className="dropdown-item">
                    404 Page
                  </Link>
                </div>
              </div> */}

              <Link to="/Contact" className="nav-item nav-link">
                Contact Us
              </Link>
              <a href="/admin/" className="nav-item nav-link">
                Login
              </a>


              {/* <Link to="" className='nav-item nav-link'> Login</Link> */}
            </div>

            <Link
              to="/Register"
              className="btn btn-primary rounded-pill py-2 px-4"
            >
              Let's Meet
            </Link>
          </div>
        </nav>
      </div>
      {/* Navbar & Hero End */}
    </div>
  );
}

export default Header;
